import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

async function boot() {
  // Dev-only contract mock (src/mocks). Vite replaces the env check with a
  // constant, so a production build drops this branch and the import.
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === '1') {
    const { startMockApi } = await import('./mocks/browser')
    await startMockApi()
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

boot()
